const getDisplayPrice = ({
  rebateValue,
  productPrice,
  lineItemPrice,
  lineItemRebatesApplied,
  optionRebatesApplied,
  minAddOnPrice,
}) => {
  let adjustedPrice = productPrice - rebateValue;

  if (lineItemRebatesApplied.length > 0) {
    const currentPrice = lineItemPrice && Number(lineItemPrice.replace('$', ''));

    adjustedPrice = currentPrice;

    if (optionRebatesApplied.length === 0) {
      adjustedPrice = currentPrice - rebateValue;
    }
  }

  if (adjustedPrice < minAddOnPrice) {
    adjustedPrice = minAddOnPrice;
  }

  return adjustedPrice.toFixed(2).replace('.00', '');
};

const getAddOnHeader = ({
  addOn,
  addOn: {
    content: {
      priceTitle
    },
  },
  productPrice,
  lineItemPrice,
  lineItemRebatesApplied,
  optionRebatesApplied,
}) => {
  const {
    bonus: { rebateValue },
    values: { minAddOnPrice },
  } = addOn;
  const displayPrice = getDisplayPrice({
    rebateValue,
    productPrice,
    lineItemPrice,
    lineItemRebatesApplied,
    optionRebatesApplied,
    minAddOnPrice,
  });

  if (displayPrice <= 0) {
    return priceTitle || 'Get it for FREE';
  }
  return `Get it for only $${displayPrice}`;
};

export default getAddOnHeader;
